import { r as registerInstance, c as createEvent, h, g as getElement } from './index-d4808923.js';
import { b as bem, h as hasNamedSlot, g as global$1 } from './index.esm-7182addc.js';
import { t as toggleBodyScrolling } from './toggleBodyScrolling-727a628b.js';

const gravityProcessModalCss = "@keyframes scroll-shadow{0%{opacity:0}3%,100%{opacity:1}}.process-modal{background-color:#FFFFFF;border-radius:8px;box-shadow:0px 16px 24px 0px rgba(0, 15, 30, 0.0588235294), 0px 4px 8px 0px rgba(0, 15, 30, 0.0196078431);box-sizing:border-box;display:flex;flex-direction:column;height:100%;max-height:var(--modal-height, 1575px);max-width:var(--modal-width, 2800px);opacity:0;overflow:hidden;position:relative;transform:scale(0.98);transform-origin:50% 50%;transition:all 150ms cubic-bezier(0.32, 0, 0.32, 1);width:100%}.process-modal--show{opacity:1;transform:none}.process-modal--width-large{max-width:640px}.process-modal--height-auto{height:auto;max-height:100%}.process-modal__overlay{align-items:center;backdrop-filter:blur(10px);background-color:rgba(0, 15, 30, 0.6);box-sizing:border-box;display:flex;height:100%;justify-content:center;left:0;opacity:0;overflow:hidden;padding:48px;pointer-events:none;position:fixed;top:0;transition:opacity 150ms linear;width:100%;z-index:3000}.process-modal__overlay--visible{opacity:1;pointer-events:auto}@media screen and (max-width: 650px){.process-modal__overlay{padding:16px}}.process-modal__header{align-items:center;border-bottom:1px solid rgba(0, 15, 30, 0.05);box-sizing:border-box;display:flex;flex:0 0 auto;height:76px;padding:20px 32px 20px 40px}@media screen and (max-width: 1000px){.process-modal__header{height:unset}}@media screen and (max-width: 650px){.process-modal__header{padding:12px 12px 12px 16px}}.process-modal__heading{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.process-modal__close-button{all:unset;border-radius:50%;cursor:pointer;margin-inline-start:auto}.process-modal__close-button:focus-visible{outline:#1B6AEE solid 2px;outline-offset:2px}.process-modal__body{flex:1 1 auto;overflow-y:auto;position:relative}.process-modal__body--padding{padding:32px 40px}@media screen and (max-width: 650px){.process-modal__body--padding{padding:16px}}.process-modal__body::after{animation:scroll-shadow linear reverse;animation-timeline:scroll();bottom:0px;box-shadow:0 12px 24px 36px #FFFFFF;content:\"\";display:block;height:0px;opacity:0;pointer-events:none;position:sticky;width:100%;z-index:1}.process-modal__body ::slotted([slot=body]){min-height:100%;position:relative}.process-modal__footer{align-items:center;border-top:1px solid rgba(0, 15, 30, 0.05);box-sizing:border-box;display:flex;flex:0 0 auto;height:80px;padding:24px 40px}@media screen and (max-width: 1000px){.process-modal__footer{height:64px}}@media screen and (max-width: 650px){.process-modal__footer{padding:16px}}.process-modal__footer--empty{display:none}";
const GravityProcessModalStyle0 = gravityProcessModalCss;

const GravityProcessModal = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.isOpen = createEvent(this, "isOpen", 5);
        this.generateClassNames = bem('process-modal');
        /**
         * Handles the ESC key press event. When the ESC key is pressed and the modal is visible, it closes the modal.
         * @param {KeyboardEvent} event - The keyboard event.
         * @private
         */
        this.handleEscKeyPress = (event) => {
            if (event.key === 'Escape' && this.isVisible && this.closeable) {
                this.closeModal();
            }
        };
        /**
         * Handles a click event on the backdrop (dimmed background). If the modal is closable and visible, it closes the modal.
         * @private
         */
        this.handleBackdropMouseDown = (event) => {
            const { target } = event;
            if (target == this.backdropElement && this.closeable && this.isVisible) {
                this.closeModal();
            }
        };
        /**
         * Handles a click event on the close button. If the modal is visible, it closes the modal.
         * @private
         */
        this.handleCloseButtonClick = () => {
            if (this.isVisible) {
                this.closeModal();
            }
        };
        this.bodyPadding = true;
        this.closeable = false;
        this.for = '';
        this.heading = '';
        this.height = 'fill';
        this.open = false;
        this.width = 'fill';
        this.hasFooterContent = false;
        this.isVisible = false;
    }
    updateOpenStatus(newValue, oldValue) {
        if (newValue !== oldValue) {
            if (this.open && !this.isVisible) {
                this.openModal();
            }
            else if (!this.open && this.isVisible) {
                this.closeModal();
            }
        }
    }
    setModalHeight(newValue) {
        if (newValue === 'auto' || newValue === 'fill') {
            this.element.style.removeProperty('--modal-height');
        }
        else {
            this.element.style.setProperty('--modal-height', newValue);
        }
    }
    setModalWidth(newValue) {
        if (newValue === 'large' || newValue === 'fill') {
            this.element.style.removeProperty('--modal-width');
        }
        else {
            this.element.style.setProperty('--modal-width', newValue);
        }
    }
    /**
     * Opens the modal and emits the `isOpen` event.
     * @private
     */
    openModal() {
        this.isVisible = true;
        this.open = true;
        toggleBodyScrolling('off');
        this.isOpen.emit(this.open);
    }
    /**
     * Closes the modal, then emits the `isOpen` event after a brief delay for the CSS transition.
     * @private
     */
    closeModal() {
        this.open = false;
        this.isVisible = false;
        toggleBodyScrolling('on');
        setTimeout(() => {
            this.isOpen.emit(this.open);
        }, 150);
    }
    /**
     * Sets up the trigger element that opens the modal when clicked.
     * Fetches the trigger element based on the 'for' property value.
     * If 'for' is provided, it attempts to find an element with matching ID within the parent node.
     * If 'for' is not provided or no element is found, it defaults to the parent element of the modal.
     * If a valid 'for' prop is provided, it also binds a click event listener to the trigger element that opens the modal.
     * @private
     */
    setupTriggerElement() {
        var _a;
        // Determine the trigger element.
        this.triggerElement = (this.for
            ? ((_a = this.element.parentNode) === null || _a === void 0 ? void 0 : _a.querySelector(`#${this.for}`)) || this.element.parentElement
            : this.element.parentElement);
        // Bind the click event listener if a valid trigger element is set.
        if (this.for && this.triggerElement) {
            this.triggerElement.onclick = () => {
                if (!this.isVisible) {
                    this.openModal();
                }
            };
        }
    }
    renderHeader() {
        if (this.heading || this.closeable) {
            return (h("div", { class: this.generateClassNames('header') }, this.heading && (h("gravity-heading", { class: this.generateClassNames('heading'), size: "medium", weight: "medium" }, this.heading)), this.closeable && (h("button", { class: this.generateClassNames('close-button'), onClick: this.handleCloseButtonClick }, h("gravity-icon", { name: "close", size: "small" })))));
        }
    }
    renderBody() {
        return (h("div", { class: this.generateClassNames('body', { padding: this.bodyPadding }) }, h("slot", { name: "body" })));
    }
    renderFooter() {
        return (h("div", { class: this.generateClassNames('footer', { empty: !this.hasFooterContent }) }, h("slot", { onSlotchange: () => (this.hasFooterContent = hasNamedSlot(this.element, 'footer')), name: "footer" })));
    }
    connectedCallback() {
        this.escKeyListener = this.handleEscKeyPress.bind(this);
        global$1.window.addEventListener('keydown', this.escKeyListener);
    }
    componentWillLoad() {
        this.setupTriggerElement();
        if (this.height) {
            this.setModalHeight(this.height);
        }
        if (this.width) {
            this.setModalWidth(this.width);
        }
        if (this.open) {
            this.openModal();
        }
        this.hasFooterContent = hasNamedSlot(this.element, 'footer');
    }
    disconnectedCallback() {
        toggleBodyScrolling('on');
        global$1.window.removeEventListener('keydown', this.escKeyListener);
        this.element.remove();
    }
    render() {
        return (h("div", { key: '928a3ebcab20cc190f24a6af963ff22634572f6b', ref: (el) => (this.backdropElement = el), class: this.generateClassNames('overlay', { visible: this.isVisible }), onMouseDown: this.handleBackdropMouseDown }, h("div", { key: '0549dae545bdd002c90c46c811ee334ec2982c24', class: `
            ${this.generateClassNames({
                show: this.open,
            })}
            process-modal--width-${this.width}
            process-modal--height-${this.height}
          ` }, this.renderHeader(), this.renderBody(), this.renderFooter())));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "open": ["updateOpenStatus"],
        "height": ["setModalHeight"],
        "width": ["setModalWidth"]
    }; }
};
GravityProcessModal.style = GravityProcessModalStyle0;

export { GravityProcessModal as gravity_process_modal };

//# sourceMappingURL=gravity-process-modal.entry.js.map